import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-3Ug1C",
  "use": "left-3Ug1C-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"left-3Ug1C\"><path fill-rule=\"evenodd\" d=\"M2.4 6l4.8-4.8L6 0 0 6l6 6 1.2-1.2L2.4 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol